module.exports = __webpack_public_path__ + "img/img17.c91951b7.svg";